import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { Entity } from "@common/types/entity";
import { useMemo } from "react";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import { useGoToClientEntitySettings } from "@components/organizationView/clients/useGoToClientEntitySettings";
import { WorkspaceDetailsRow } from "./workspaceViewConfig";

export const EntitiesCell = ({
    getValue,
    row,
}: CellContext<ViewTableFeatures, WorkspaceDetailsRow, Entity[]>) => {
    const sortedEntities = useMemo(
        () =>
            [...getValue()].sort((a, b) => {
                if (a.isBusiness !== b.isBusiness) {
                    return a.isBusiness ? -1 : 1;
                }
                const aName = a.name ?? "";
                const bName = b.name ?? "";
                return aName.localeCompare(bName);
            }),
        [getValue],
    );

    const handleEntitySelected = useGoToClientEntitySettings();

    if (sortedEntities.length === 0) {
        return null;
    }

    return (
        <CaptureClicks>
            <EntityAvatarGroup
                entities={sortedEntities}
                max={5}
                size="sm"
                onEntityClick={(entity) =>
                    handleEntitySelected(row.original.workspace.id, entity.id)
                }
            />
        </CaptureClicks>
    );
};
